import { render } from "./DashboardCampaignMetrics.vue?vue&type=template&id=afffe68c&scoped=true"
import script from "./DashboardCampaignMetrics.vue?vue&type=script&lang=js"
export * from "./DashboardCampaignMetrics.vue?vue&type=script&lang=js"

import "./DashboardCampaignMetrics.vue?vue&type=style&index=0&id=afffe68c&lang=scss&scoped=true"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-afffe68c"]])

export default __exports__